import React, { useState } from 'react';
import { useForm } from 'react-hook-form';
import { SharedIconArrowLongDown } from '../icons';
import { Button } from '@chakra-ui/react';
import { DynamicInput, getDefaultValue } from '../form-elements';
import { API_URL } from '../../../services';
import { IncomeCalculatorBusinessRequest } from '../../../@types/shared/income-calculator/income-calculator-business-request';

type SharedIncomeCalculatorBusinessProps = {
  toggleIncomeCalculator: (value: string) => void;
  toggleLastStep: () => void;
};

const fields = ['ld', 'lvu', 'ov', 'sfw', 'bpga'];
const labels = [
  'Saldo fiscale winst',
  'Loonvervangende uitkeringen',
  'Ontslagvergoeding',
  'Loondienst',
  'Bijtelling prive gebruik auto'
];

const currentYear = new Date().getFullYear();
const years = [currentYear - 1, currentYear - 2, currentYear - 3];

const SharedIncomeCalculatorBusinessForm: React.FC<SharedIncomeCalculatorBusinessProps> = ({
  toggleIncomeCalculator,
  toggleLastStep
}) => {
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const {
    register,
    handleSubmit,
    formState: { errors, isValid, isDirty }
  } = useForm<IncomeCalculatorBusinessRequest>({
    mode: 'onChange'
  });
  const onSubmit = async (data: IncomeCalculatorBusinessRequest) => {
    setIsLoading(true);
    const queryString = new URLSearchParams(data as unknown as Record<string, string>);

    const res = await API_URL.get<{
      code: string;
      status: string;
      it: number;
    }>(
      `https://raadhuys.nodum.io/api/hypotheker-api?apiKey=91da9493217153354c8e954b3ecfb5dbc21f431f&${queryString}`
    );
    setIsLoading(false);
    toggleIncomeCalculator(res.it.toString());
  };

  return (
    <div>
      <form onSubmit={handleSubmit(onSubmit)}>
        <div className="hidden md:grid grid-cols-5 md:mb-8">
          <div></div>
          {years.map((item) => {
            return <div key={item}>{item}</div>;
          })}
        </div>

        {fields.map((fieldName, fieldNameIndex) => {
          const inputs = [1, 2, 3].map((number, numberIndex) => {
            const name = fieldName + number;

            return (
              <div>
                <div className={`block md:hidden`}>{years[numberIndex]}</div>
                <DynamicInput
                  key={fieldName + number}
                  id={name}
                  label={null}
                  type={`currency`}
                  validation={{ required: fieldName === 'ld' }}
                  placeholder={`2200`}
                  error={errors[name as keyof IncomeCalculatorBusinessRequest]}
                  defaultValue={getDefaultValue(`2200`)}
                  register={register}
                />
              </div>
            );
          });

          return (
            <div className="grid grid-cols-1 md:grid-cols-5 gap-4" key={fieldName}>
              <div className={`font-bold text-h2`}>{labels[fieldNameIndex]}</div>
              {inputs}
            </div>
          );
        })}

        <div className={`mt-8 flex justify-between`}>
          <Button
            type="submit"
            isLoading={isLoading}
            colorScheme="orange"
            loadingText={'Bezig met versturen'}
            isDisabled={false}>
            {!isValid && isDirty ? `Wat moet ik nog invullen?` : `Reken verder`}
          </Button>
          <Button variant={`ghost`} onClick={toggleLastStep} ml={4}>
            <SharedIconArrowLongDown className={`rotate-90 mr-4`}></SharedIconArrowLongDown> Vorige
            stap
          </Button>
        </div>
      </form>
    </div>
  );
};

export default SharedIncomeCalculatorBusinessForm;
